/* eslint-disable no-shadow */
import { STRINGS } from 'config';

export const initialState = {
  isStatePersisted: true,
  isAutoSubmitted: true,
  isClinicalReviewMode: true,
  isAutoFocusEnabled: false,
  showSessionExpiryValidationOnLoad: false,
  forceNhsLoginMode: false,
  isETriageBackHidden: false,
};

const flags = STRINGS.FLAGS_REDUCER;

export const flagsReducer = (preloadedState = initialState, action = {}) => {
  const state = { ...initialState, ...preloadedState };
  switch (action.type) {
    case flags.SET_IS_CLINICAL_REVIEW_MODE:
      return { ...state, isClinicalReviewMode: action.payload };
    case flags.CLEAR_SHOW_SESSION_EXPIRY_VALIDATION_ON_LOAD:
      return { ...state, showSessionExpiryValidationOnLoad: false };
    case STRINGS.SESSION_REDUCER.SET_SESSION_EXPIRY_VALIDATION:
      return { ...state, showSessionExpiryValidationOnLoad: true };
    case flags.SET_FORCE_NHS_LOGIN_MODE:
      return { ...state, forceNhsLoginMode: action.payload };
    case flags.SET_IS_ETRIAGE_BACK_HIDDEN:
      return { ...state, isETriageBackHidden: action.payload };
    default:
      return state;
  }
};
